import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { AlertType, EmailConfirmStatus, KeyErrors, KeySuccess } from '../../../store/enums';
import { useRoutesHelper } from '../../../helpers/routesHelper';
import { setResultInfo } from '../../../store/resultInformarion/actions';

const EmailConfirmPage = () => {
  const dispatch = useDispatch();
  const { status } = useParams<{ status: string }>();
  const history = useHistory();
  const { getProfileRoute, getResultStatusRoute } = useRoutesHelper();

  useEffect(() => {
    if (status) {
      const isSuccess = status === EmailConfirmStatus.Success;
      const alertType = isSuccess ? AlertType.Success : AlertType.Error;
      const alertKey = isSuccess ? KeySuccess.EmailConfirmed : KeyErrors.EmailConfirmFailed;
      const message = isSuccess
        ? 'Alert.NowYouCanLogInUsingYourEmailAndPassword'
        : 'Alert.EmailVerificationLinkIsInvalidOrOutOfDate';
      const title = isSuccess ? 'Alert.EmailConfirmed' : 'Alert.SomethingWentWrong';

      dispatch(
        setResultInfo({
          type: alertType,
          key: alertKey,
          title,
          message,
          buttons: [
            {
              title: 'Registration.GoToLogin',
              callback: () => history.push(getProfileRoute()),
            },
          ],
        })
      );
      history.push(getResultStatusRoute(alertType, alertKey));
    }
  }, [dispatch, getProfileRoute, history, status]);

  return null;
};

export default EmailConfirmPage;
